import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CdkOverlayContainer extends OverlayContainer {
  /**
   * Set the container element from the outside, e.g. from the corresponding directive
   */
  public myCreateContainer(element: HTMLElement): void {
    const container = document.createElement('div');
    container.classList.add('cdk-overlay-container');
    container.style.position = 'absolute';
    element.appendChild(container);
    this._containerElement = container;
  }
  /**
   * Prevent creation of the HTML element
   */
  protected override _createContainer(): void {
    if (this._containerElement) {
      return;
    }
    super._createContainer();
  }
}
